import { ContactList } from './ContactList';

export default ContactList;
